export const iconButtonSx = {
    color: (theme) => theme.palette.text.secondary,
    transition: 'all 0.2s ease',
    '&:hover': {
        color: (theme) => theme.palette.primary.main,
        backgroundColor: 'rgba(0,0,0,0.04)',
    },
};
